






import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch,
  Mixins
} from "vue-property-decorator";
import { ParentMixin } from "@/mixins/multiParentMixin";

@Component({
  components: {}
})
export default class TabBar extends Mixins(ParentMixin) {
  @Prop({ default: "home-tab-bar" })
  private iconClass: any;
  @Prop({ default: "home-tab-label" })
  private labelClass: any;
  @Prop({ default: true })
  private lineTop: any;
}
